'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _unistore = require('unistore');

var _unistore2 = _interopRequireDefault(_unistore);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WHITE = '#ffffff';

var initialState = {
  product: null,

  menus: [],

  profile: null,
  loggedIn: false,

  config: {
    color: null,
    inverseColor: WHITE,
    textColor: WHITE,

    background: null,
    backgroundInScroll: null,

    gradient: false,
    gradientColor: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(178, 178, 178, 0))',

    full: false,
    singleCTA: false,
    profileDisabled: false
  },

  brand: {
    path: '/',
    logo: {
      default: null,
      negative: null,
      alt: ''
    },
    callback: undefined
  },

  login: {
    path: '/entrar',
    callback: undefined,
    loginAccessibleLabel: 'Fazer login na Serasa',
    text: 'Login',
    disabledInNavbar: false,
    disabledInProfile: false
  },

  signUp: {
    path: '/cadastrar',
    callback: undefined,
    text: 'Cadastre-se',
    textInMenu: 'Cadastre-se',
    signUpAccessibleLabel: 'Fazer cadastro na Serasa',
    accessibleTextLabel: 'Fazer cadastro na Serasa',
    disabledInNavbar: false,
    disabledInProfile: false
  },

  logout: {
    callback: undefined
  },

  notification: {
    active: false,
    loading: false,
    unreadLoaded: false,
    unread: 0,
    list: []
  },

  metric: {
    category: null
  },

  environment: 'development',

  // Private
  heimdall: {
    host: '',
    api: '',
    notificationApi: '',
    notificationApiKey: '',
    dropdown: {
      menu: false
    },
    pages: [{ id: 1, label: 'Consultar meu CPF', url: '/consultar-meu-cpf' }, { id: 3, label: 'Pedir empréstimo on-line', url: '/ecred' }, { id: 4, label: 'Consultar pontuação do Score', url: '/score' }, { id: 5, label: 'Monitorar meu CPF', url: '/premium/monitoramento-cpf' }, { id: 6, label: 'Limpar meu nome', url: '/limpa-nome-online' }, { id: 7, label: 'Negociar minhas dívidas', url: '/limpa-nome-online' }, { id: 8, label: 'Falar com a Serasa', url: '/atendimento' }, { id: 9, label: 'Atualizar meus dados', url: '/meus-dados/alterar-dados/' }, { id: 10, label: 'Soluções para empresas', url: '//empresas.serasaexperian.com.br' }, { id: 11, label: 'Proteção de Dados Pessoais', url: '/protecao-dados-pessoais/' }],
    products: [{ key: 'ecred', name: 'Serasa Crédito', url: '/credito' }, { key: 'premium', name: 'Serasa Premium', url: '/premium/' }, { key: 'limpa-nome', name: 'Serasa Limpa Nome', url: '/limpa-nome-online/' }, { key: 'score', name: 'Serasa Score', url: '/score/' }, { key: 'carteira-digital', name: 'Serasa Carteira Digital', url: '/carteira-digital' }, { key: 'cadastro-positivo', name: 'Serasa Cadastro Positivo', url: '/cadastro-positivo/' }, { key: 'voce-consulta', name: 'Você Consulta', url: '/voceconsulta/' }],
    profiles: [{ key: 'perfil', label: 'Meu perfil', path: '/meu-perfil' }, { key: 'edit', label: 'Editar dados', path: '/meus-dados/alterar-dados/' }, { key: 'logout', label: 'Sair', logout: true }],
    endpoints: {
      logout: '/user/logout',
      notification: {
        get: function get() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { offset: 0, limit: 5 },
              offset = _ref.offset,
              limit = _ref.limit;

          return '/ecred/v1/notifications?offset=' + offset + '&limit=' + limit;
        }, // GET
        unread: '/ecred/v1/notifications/count', // GET
        read: function read(notificationId) {
          return '/ecred/v1/notifications/' + notificationId;
        } // PUT
      }
    },
    environments: {
      development: {
        host: 'https://serasa.dev',
        api: 'https://api-auth.serasa.dev/v1',
        ecred: {
          api: 'https://apigw-ecred-hml.ecsbr.net',
          apiKey: '8ifkjacsEu4AwRC9dPPJBwLqxi4dFGbg'
        }
      },
      homologation: {
        host: 'https://serasa.dev',
        api: 'https://api-auth.serasa.dev/v1',
        apiKey: 'KLZAVgYVU58DfvpbCUeTd1ojj3CIVkn4awJJyrRa',
        ecred: {
          api: 'https://apigw-ecred-hml.ecsbr.net',
          apiKey: '8ifkjacsEu4AwRC9dPPJBwLqxi4dFGbg'
        }
      },
      production: {
        host: 'https://www.serasa.com.br',
        api: 'https://api-auth.serasa.com.br/v1',
        apiKey: 'LFGO3deJs38Pr0n5DLFVL52YNcl2vUjV6aXFTe0j',
        ecred: {
          api: 'https://apigw-ecred-prd.ecsbr.net',
          apiKey: '8ifkjacsEu4AwRC9dPPJBwLqxi4dFGbg'
        }
      }
    }
  }
};

function createReducerStore(state, reducer) {
  var store = (0, _unistore2.default)(state);

  // our reducer is actually an action (they're the same thing!):
  var reduce = store.action(reducer);

  // replacing store.action lets us change how connect() works:
  store.action = function (fn) {
    return function () {
      var action = fn.apply(undefined, arguments);
      if (action && action.then) {
        return action.then(reduce);
      }
      return reduce(action || { type: _types.NOOP });
    };
  };

  // creating store.actions allows passing an object of actions
  store.actions = function (actions) {
    return (0, _entries2.default)(actions).reduce(function (acc, cur) {
      acc[cur[0]] = store.action(cur[1]);
      return acc;
    }, {});
  };

  store.dispatch = function (args) {
    return reduce(args);
  };

  return store;
}

var store = createReducerStore(initialState, _reducer2.default);

exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/store.js
// module id = 14
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38